import React from "react";
import { connect } from "react-redux";
import IFrameWrapper, { TAGGED_ELEMENT } from "../shared/IFrameWrapper";

export const StartClaim = ({ iframeSrc }) => {
  return (
    <IFrameWrapper
      iframeSrc={iframeSrc}
      heightCalculationMethod={TAGGED_ELEMENT}
      title="Make a claim"
    />
  );
};

export const mapStateToStartClaim = (state) => {
  return {
    iframeSrc: state.makeAClaimReducer.iframeSrc
  };
};

export default connect(mapStateToStartClaim)(StartClaim);
